import { useProductData } from '@composables/useProductData';
/**
 * @param {ProductId} productId
 * @param {SelectedColorId} selectedColorId
 * @returns {null | string}
 */
export const useTypeBySelectedColor = (productId, selectedColorId) => {
  const product = useProductData(productId)?.value;
  const typeMap = product?.traits?.types?.typeMap;

  if (!typeMap) return null;

  const typeObject = Object.entries(typeMap)
    .find(([, typeValue]) => Object.entries(typeValue.colors || {})
      .some(([, colorId]) => colorId === selectedColorId));

  return typeObject?.[0] || null;
};

export default useTypeBySelectedColor;
